

  
  var mySwiper = new Swiper ('.logo-sliderss', {
  loop: true,
  autoplay: {
    delay: 1,
    disableOnInteraction: false
  },
    spaceBetween: 120,
    slidesPerView: "auto",
      speed: 4000,
 
    // If we need pagination
    pagination: '.swiper-pagination',
    
    // Navigation arrows
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
  });
  
